<template>
  <div class="automation-configure-signal-settings-component" v-bind:class="{loaded, loading}">
    <div v-if="!loaded">
      <a-form-model-item label="Laden">
        <Skeleton class="skeleton" v-bind:loading="true" style="width: 100%; height: 32px;"></Skeleton>
      </a-form-model-item>
    </div>
    <div v-else>
      <div class="flex-col gap-y-md">
        <dd-input
            title="Naam van automation"
            rules="required"
            v-model="title"
            name="Naam"
            placeholder="Naam"
            v-bind:disabled="isGlobal"
        ></dd-input>

        <dd-textarea
            title="Omschrijving"
            rules="required"
            v-model="description"
            name="Omschrijving"
            style="width: 100%"
            placeholder="Omschrijving"
            v-bind:disabled="isGlobal"
        ></dd-textarea>

        <dd-radio-group
            title="Wil je de campagne eenmalig of automatisch draaien?"
            class="mb-md"
            v-model="run_interval"
            name="run-interval"
            group-name="run-interval"
            rules="required"
        >
          <dd-radio value="never">Niet uitvoeren</dd-radio>
          <dd-radio value="once">Eenmalig</dd-radio>
          <dd-radio value="daily">Dagelijks</dd-radio>
          <dd-radio value="weekly">Wekelijks</dd-radio>
          <dd-radio value="monthly">Maandelijks</dd-radio>
        </dd-radio-group>

        <dd-switch title="Resultaten opnieuw genereren" v-model="is_recurring"
                   name="is_recurring"></dd-switch>

        <dd-switch title="Resultaten tijdelijk niet opnieuw genereren" v-model="temporary_exclude_recurring"
                   name="temporary_exclude_recurring"></dd-switch>

        <div v-if="temporary_exclude_recurring">
          <dd-input
              value="Number"
              title="Aantal dagen uitsluiten"
              rules="integer"
              v-model="temporary_exclude_recurring_duration.days"
              name="temporary_exclude_recurring_duration_days"
              placeholder="0"
          ></dd-input>

          <dd-input
              value="Number"
              title="Aantal weken uitsluiten"
              rules="integer"
              v-model="temporary_exclude_recurring_duration.weeks"
              name="temporary_exclude_recurring_duration_weeks"
              placeholder="0"
          ></dd-input>

          <dd-input
              value="Number"
              title="Aantal maanden uitsluiten"
              rules="integer"
              v-model="temporary_exclude_recurring_duration.months"
              name="temporary_exclude_recurring_duration_months"
              placeholder="0"
          ></dd-input>

          <dd-input
              value="Number"
              title="Aantal jaren uitsluiten"
              rules="integer"
              v-model="temporary_exclude_recurring_duration.years"
              name="temporary_exclude_recurring_duration_years"
              placeholder="0"
          ></dd-input>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {Skeleton} from 'vue-loading-skeleton'
import {mapActions, mapGetters, mapState} from "vuex";
import store from '../store'
import {RunIntervalEnum} from '../enums'
import AutomationDescriptionComponent from "./DescriptionComponent.vue";
import {mapFields} from "vuex-map-fields";

export default {
  name: 'GeneralSettings',
  components: {
    AutomationDescriptionComponent,
    Skeleton
  },
  data() {
    return {
      loading: true,
      loaded: false,
    }
  },
  mounted() {
    const STORE_KEY = '$_automation'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }

    Promise.all([
      this.fetchAutomationActions(),
      this.fetchSearches()
    ])
        .finally(() => {
          this.loading = false
          this.loaded = true
        })
  },
  computed: {
    RunIntervalEnum() {
      return RunIntervalEnum
    },
    ...mapGetters({
      automationActions: '$_automation/automationActions',
      searches: '$_automation/searches',
      dynamicExtendingSearches: '$_automation/dynamicExtendingSearches',
    }),
    ...mapState(`$_automation`, {
      value: (state) => state.creatingAutomation,
    }),
    ...mapFields(`$_automation`, [
      'creatingAutomation.title',
      'creatingAutomation.description',
      'creatingAutomation.run_interval',
      'creatingAutomation.is_recurring',
      'creatingAutomation.needs_verification',
      'creatingAutomation.temporary_exclude_recurring',
      'creatingAutomation.temporary_exclude_recurring_duration',
    ]),
    isGlobal() {
      return this.value.global_automation_id !== undefined
    },
  },
  methods: {
    ...mapActions('$_automation', [
      'fetchAutomationActions',
      'fetchSearches',
    ]),
  },
}
</script>

<style scoped lang="scss">
.automation-configure-signal-settings-component {
  position: relative;

  .ant-select {
    width: 100% !important;
    display: block !important;
  }
}
</style>
